import { render } from "./MustConsent.vue?vue&type=template&id=9c28bf54"
import script from "./MustConsent.vue?vue&type=script&lang=js"
export * from "./MustConsent.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "9c28bf54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c28bf54', script)) {
    api.reload('9c28bf54', script)
  }
  
  module.hot.accept("./MustConsent.vue?vue&type=template&id=9c28bf54", () => {
    api.rerender('9c28bf54', render)
  })

}

script.__file = "resources/js/Components/MustConsent.vue"

export default script